import { Observable } from 'rxjs';

import { UseCase }
from '../../base/use-case';

import { CategoryAcademyModel, DataCategoryAcademyModel }
from '../../models/academy/category-academy.model';

import { AcademyRepository }
from '../../repositories/academy.repository';

export class UpdateCategoryAcademyUseCase implements UseCase< DataCategoryAcademyModel, CategoryAcademyModel> {

    constructor(
        private repository:
        AcademyRepository
    ) {}

    execute(
        params: DataCategoryAcademyModel
    ):
    Observable<CategoryAcademyModel> {

        return this.repository
            .updateCategoryAcademy(
                params
            );
    }
}